import { createLightTheme } from 'baseui';

// https://baseweb.design/guides/theming/

export const basewebTheme = createLightTheme({
  typography: {
    HeadingXXLarge: {
      fontSize: '32px',
      fontWeight: 500
    },
    HeadingXLarge: {
      fontSize: '28px',
      fontWeight: 500
    },
    HeadingLarge: {
      fontSize: '24px',
      fontWeight: 500
    },
    HeadingMedium: {
      fontSize: '20px',
      fontWeight: 500
    },
    HeadingSmall: {
      fontSize: '16px',
      fontWeight: 500
    }
  }
});